<template>
  <h1>Quote</h1>
</template>

<script setup lang="ts"></script>

<style lang="postcss" scoped></style>
